import BigNumber from 'bignumber.js';

export default function isPositiveAndNotZeroNumber(num) {
  const numBn = new BigNumber(num);
  return !numBn.isNaN() && numBn.isGreaterThan(0);
}
